import React from "react";

import SubstractSvg from "../../assets/images/icons/substract.svg";

export const SubstractIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={SubstractSvg}
        alt={alt || "Substract"}
    />
);
